var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav-wrapper",attrs:{"ar":_vm.$i18n.locale === 'ar'}},[_c('span',{directives:[{name:"t",rawName:"v-t",value:('home'),expression:"'home'"}]}),_c('img',{attrs:{"src":require("@/assets/imgs/home/arrow_right_8x11.png"),"alt":""}}),_c('span',{directives:[{name:"t",rawName:"v-t",value:(_vm.$route.name),expression:"$route.name"}]})])
}
var staticRenderFns = []

export { render, staticRenderFns }